export enum StorageDivaMedia {
  Group = "Group",
  DiskArray = "DiskArray",
  Default = "Default",
}
